export default __webpack_public_path__ + "static/media/icon-day-off.bdb1f75e.svg";